export enum TimeSelectorActions {
  SetStartTime = "time_selector/set_start_time",
  SetMillLocalTime = "time_selector/set_mill_local_time",
  SetDateTime = "time_selector/set_time_selector_dateTimes",
}

export const setStartTime = (newDate: Date | null, offset: number) => {
  return {
    type: TimeSelectorActions.SetStartTime,
    payload: { newDate, offset },
  };
};

export const setDateTime = (startDateTime: string, endDateTime: string, millLocalDateTime: string) => {
  return {
    type: TimeSelectorActions.SetDateTime,
    payload: { startDateTime, endDateTime, millLocalDateTime },
  };
}

export const SetMillLocalTime = (offset: number) => {
  return {
    type: TimeSelectorActions.SetMillLocalTime,
    payload: offset,
  };
};
